import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

export const FieldHoleStatus = ({ LangFile, selectedField, hectaresToAdd }) => {
  const rows = [
    {
      label: LangFile.PolygonDrawing.cultivatedArea + ':',
      value: `${selectedField.size.toFixed(2)} ha`,
    },
    {
      label: LangFile.PolygonDrawing.drawnInnerBoundaryArea + ':',
      value: `${hectaresToAdd} ha`,
      style: { marginBottom: '12px' },
    },
    {
      label: LangFile.PolygonDrawing.newCultivatedArea + ':',
      value: `${(selectedField.size - hectaresToAdd).toFixed(2)} ha`,
    },
  ];

  return (
    <Box>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: '8px',
          backgroundColor: '#ddd',
        }}
      />
      {rows.map(({ label, value, style }, index) => (
        <Box
          key={index}
          style={style}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="body2">{label}</Typography>
          <Typography variant="body2" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
